import React, {useCallback, useEffect, useState, useMemo} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import styles from "../designs/AdminPage.module.css";
import {useUser} from "./UserContext";

// Безпечний доступ до Telegram initData скрізь
const getInitDataSafe = () => {
    try {
        return window?.Telegram?.WebApp?.initData || "";
    } catch {
        return "";
    }
};

// безпечне JSON.stringify + обрізання дуже великих текстів
// ---------- SAFE HELPERS (додай зверху файла) ----------
const safeStringify = (obj, space = 2, maxLen = 4000) => {
    try {
        const s = JSON.stringify(obj, null, space);
        return s.length > maxLen ? s.slice(0, maxLen) + " …" : s;
    } catch {
        try {
            return String(obj);
        } catch {
            return "—";
        }
    }
};

const safeArray = (v) => Array.isArray(v) ? v : [];
const safeNum = (v, def = 0) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
};
const tryDate = (v) => {
    if (!v) return 0;
    const t = Date.parse(v);
    return Number.isFinite(t) ? t : 0;
};

const DEFAULT_REGULAR_POST_TEMPLATE = `💚 <b>Ставка дня</b>

<b><Матч> — <час></b>
<i><Ліга/країна, якщо є></i>

<blockquote>👉 <b>Ставка:</b> <ринок українською> — кеф <b>X.XX</b></blockquote>

<b>Спостереження:</b>
<blockquote>
• <перевірений факт №1>
• <перевірений факт №2>
• <за потреби третій факт>
</blockquote>

<b>Висновок:</b> <короткий підсумок>`;

const DEFAULT_RESULT_POST_TEMPLATE = `✅ або ❌ <b>Підсумок Ставки дня</b>

<b><Матч> — <фінальний рахунок></b>
<i><Ліга></i>

<blockquote>🎯 <b>Ставка:</b> <опублікована ставка>
<b>Результат:</b> Зайшла / Не зайшла / Повернення</blockquote>

<b>У чому прогноз був точним:</b> або <b>Що не спрацювало:</b>
<blockquote><1-2 конкретні висновки лише з фактичних даних матчу></blockquote>`;

const DEFAULT_ADMIN_SETTINGS = {
    admin_review_id: "1078623102",
    daily_channel_id: "-1002043440248",
    daily_publication_chat_id: "-1002043440248",
    daily_publication_channel_id: "-1002043440248",
    daily_publication_thread_id: "",
    daily_channel_post_time: "10:00",
    daily_channel_posts_enabled: true,
    daily_channel_regular_enabled: true,
    daily_channel_risk_enabled: true,
    daily_publish_to_chat_enabled: true,
    daily_publish_to_channel_enabled: true,
    daily_post_images_enabled: true,
    daily_post_require_approval: true,
    daily_result_posts_enabled: true,
    daily_result_require_approval: true,
    daily_result_delay_minutes: 15,
    daily_post_image_model: "gpt-image-1",
    daily_post_image_quality: "low",
    daily_regular_post_template: DEFAULT_REGULAR_POST_TEMPLATE,
    daily_result_post_template: DEFAULT_RESULT_POST_TEMPLATE,
    daily_admin_report_enabled: true,
    daily_admin_report_time: "02:30",
    scheduled_broadcasts_enabled: true,
    daily_matches_refresh_enabled: true,
    app_locked: false,
    bot_public_url: "",
    grach_family_channel_id: "",
};

const ADMIN_BETS_PAGE_LIMIT = 120;

function AdminPage() {
    const {user, loading: userLoading} = useUser();
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [bets, setBets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState("accessRequests");
    const [expandedMatches, setExpandedMatches] = useState({}); // Стан для розгорнутих матчів (груп ставок)
    const [expandedLiveUsers, setExpandedLiveUsers] = useState({}); // Розгортання LIVE ставки по користувачу (key: matchKey__telegram_id)
    const [expandedPrematch, setExpandedPrematch] = useState({}); // Показ Prematch ставки/думки по матчу (key: matchKey)
    const [selectedDate, setSelectedDate] = useState(""); // "" = всі дати
    const [showAllDates, setShowAllDates] = useState(false); // показувати всі дати чи тільки 8
    const [pageSize, setPageSize] = useState(50);
    const [usersPageSize, setUsersPageSize] = useState(40);
    const [betsLoading, setBetsLoading] = useState(false);
    const [betsHasMore, setBetsHasMore] = useState(false);
    const [betsTotal, setBetsTotal] = useState(0);
    const [betsOffset, setBetsOffset] = useState(0);
    // ── Розсилка
    const [broadcastTarget, setBroadcastTarget] = useState("access"); // 'all' | 'access' | 'no_access' | 'user'
    const [broadcastUserId, setBroadcastUserId] = useState("");
    const [broadcastText, setBroadcastText] = useState("");
    const [broadcastPhotos, setBroadcastPhotos] = useState([]);
    const [broadcastSending, setBroadcastSending] = useState(false);
    const [broadcastStatus, setBroadcastStatus] = useState("");
    // ── Запланована розсилка
    const [schedules, setSchedules] = useState([]);
    const [schedLoading, setSchedLoading] = useState(false);
    const [schedStatus, setSchedStatus] = useState("");

    const [schedEditId, setSchedEditId] = useState(null);
    const [schedTitle, setSchedTitle] = useState("");
    const [schedEnabled, setSchedEnabled] = useState(true);
    const [schedTarget, setSchedTarget] = useState("access"); // all|access
    const [schedTime, setSchedTime] = useState("10:00");      // HH:MM
    const [schedMinMatches, setSchedMinMatches] = useState(""); // '' або число
    const [schedTemplate, setSchedTemplate] = useState(
        "Привіт, {{first_name}}! Сьогодні {{matches_today}} матчів ({{weekday_today}}).\n{{no_bet_text}}"
    );
    const [schedPhoto, setSchedPhoto] = useState(null);

    const [schedPreviewOpen, setSchedPreviewOpen] = useState(false);
    const [schedPreviewUrl, setSchedPreviewUrl] = useState(null);
    const [schedPreviewTitle, setSchedPreviewTitle] = useState("");
    const [referralRequests, setReferralRequests] = useState([]);
    const [shopPurchases, setShopPurchases] = useState([]);
    const [bonusLoading, setBonusLoading] = useState(false);
    const [bonusStatus, setBonusStatus] = useState("");
    const [adminSettings, setAdminSettings] = useState(DEFAULT_ADMIN_SETTINGS);
    const [settingsLoading, setSettingsLoading] = useState(false);
    const [settingsSaving, setSettingsSaving] = useState(false);
    const [settingsStatus, setSettingsStatus] = useState("");
    const [channelAudit, setChannelAudit] = useState(null);
    const [channelAuditLoading, setChannelAuditLoading] = useState(false);
    const [channelAuditStatus, setChannelAuditStatus] = useState("");
    const [affiliateQuery, setAffiliateQuery] = useState("");
    const [affiliateProfile, setAffiliateProfile] = useState(null);
    const [affiliateLoading, setAffiliateLoading] = useState(false);
    const [affiliateStatus, setAffiliateStatus] = useState("");
    const [affiliateLinkTelegramId, setAffiliateLinkTelegramId] = useState("");
    const [affiliateLinkCid, setAffiliateLinkCid] = useState("");
    const [affiliateLinkNote, setAffiliateLinkNote] = useState("");
    const [accessRequests, setAccessRequests] = useState([]);
    const [accessRequestsLoading, setAccessRequestsLoading] = useState(false);
    const [accessRequestsStatus, setAccessRequestsStatus] = useState("");

    // фільтрація користувачів
    const [userFilter, setUserFilter] = useState("all"); // all | access | access_not_channel | channel_no_access
    const [search, setSearch] = useState("");

    const fetchAccessRequests = useCallback(async () => {
        if (!user?.telegram_id) return;
        setAccessRequestsLoading(true);
        setAccessRequestsStatus("");
        try {
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const res = await axios.get(
                `${API_BASE}/admin/access-requests?telegram_id=${user.telegram_id}&limit=200&_=${Date.now()}`,
                {
                    headers: {
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        "Pragma": "no-cache",
                        "Expires": "0",
                        "X-Telegram-Init-Data": getInitDataSafe(),
                    },
                }
            );
            setAccessRequests(safeArray(res.data?.requests));
        } catch (err) {
            console.error("fetchAccessRequests error:", err.response ? err.response.data : err.message);
            setAccessRequestsStatus(err.response?.data?.detail || "Не вдалося завантажити заявки");
        } finally {
            setAccessRequestsLoading(false);
        }
    }, [user?.telegram_id]);

    const decideAccessRequest = async (requestId, approve) => {
        if (!user?.telegram_id) return;
        const action = approve ? "надати доступ" : "відхилити заявку";
        if (!window.confirm(`Точно ${action}?`)) return;
        setAccessRequestsStatus("");
        try {
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const res = await axios.post(
                `${API_BASE}/admin/access-requests/${requestId}/decision?telegram_id=${user.telegram_id}`,
                {approve},
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        "Pragma": "no-cache",
                        "Expires": "0",
                        "X-Telegram-Init-Data": getInitDataSafe(),
                    },
                }
            );
            setAccessRequests((prev) => prev.filter((item) => item.id !== requestId));
            setAccessRequestsStatus(res.data?.message || "Заявку оброблено");
            if (approve) {
                const targetId = String(res.data?.result?.telegram_id || "");
                setUsers((prev) => prev.map((item) => (
                    String(item.telegram_id) === targetId ? {...item, has_access: true} : item
                )));
            }
        } catch (err) {
            console.error("decideAccessRequest error:", err.response ? err.response.data : err.message);
            setAccessRequestsStatus(err.response?.data?.detail || "Не вдалося обробити заявку");
        }
    };


    const availableDates = useMemo(() => {
        return [...new Set((bets || []).map((b) => b.dateKey).filter(Boolean))]
            .sort((a, b) => b.localeCompare(a));
    }, [bets]);

    const visibleBets = useMemo(() => {
        const base = selectedDate
            ? (bets || []).filter((b) => b.dateKey === selectedDate)
            : (bets || []);
        // найновіші угору, але не reverse() у JSX — робимо тут
        return [...base].sort((a, b) => {
            // спробуємо сортувати за часом генерації (якщо є), інакше стабільно
            const ta = Date.parse(a.generated_time || 0) || 0;
            const tb = Date.parse(b.generated_time || 0) || 0;
            return tb - ta;
        });
    }, [bets, selectedDate]);


    const filteredUsers = useMemo(() => {
        const term = search.trim().toLowerCase();
        const accessNotInChannelIds = new Set(
            safeArray(channelAudit?.audit?.access_not_in_channel).map((u) => String(u.telegram_id))
        );
        const channelNoAccessIds = new Set(
            safeArray(channelAudit?.audit?.channel_without_bot_access || channelAudit?.audit?.channel_not_in_bot)
                .map((u) => String(u.telegram_id))
        );

        return (users || [])
            // 1) фільтр за доступом
            .filter(u => {
                if (userFilter === "access") return !!u.has_access;
                if (userFilter === "access_not_channel") return accessNotInChannelIds.has(String(u.telegram_id));
                if (userFilter === "channel_no_access") return channelNoAccessIds.has(String(u.telegram_id));
                return true;
            })
            // 2) пошук по ніку / імені / Telegram ID / зовнішньому ID
            .filter(u => {
                if (!term) return true;
                const uname = (u.username || "").toLowerCase();
                const fname = (u.first_name || "").toLowerCase();
                const lname = (u.last_name || "").toLowerCase();
                const idStr = String(u.telegram_id || "");
                const externalId = String(u.external_id || "").toLowerCase();
                return (
                    uname.includes(term) ||
                    fname.includes(term) ||
                    lname.includes(term) ||
                    idStr.includes(term) ||
                    externalId.includes(term)
                );
            })
            // 3) невелике сортування: спершу з доступом, потім адміни
            .sort((a, b) => (Number(b.has_access) - Number(a.has_access)) ||
                (Number(b.role === "admin") - Number(a.role === "admin")));
    }, [users, userFilter, search, channelAudit]);


    const visibleUsers = useMemo(() => {
        return (filteredUsers || []).slice(0, usersPageSize);
    }, [filteredUsers, usersPageSize]);

    const formatKyivTime = (iso) => {
        if (!iso) return "";
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return String(iso); // якщо чомусь не парситься — покажемо як є
        return d.toLocaleString("uk-UA", {
            timeZone: "Europe/Kyiv",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
        });
    };


    // стабільний ключ дати для фільтра (YYYY-MM-DD)
    const toIsoDateKey = (val) => {
        if (!val) return "";
        // якщо це вже ISO «2025-10-12…»
        const s = String(val).trim();
        if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
        // якщо це повний ISO з Z
        try {
            const d = new Date(s);
            if (!Number.isNaN(d.getTime())) {
                return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
            }
        } catch {
        }
        // інакше просто зрізаємо перші 10 символів як фолбек
        return s.slice(0, 10);
    };


    // ── ДОДАТИ: безпечний парсер
    const parseMaybeJSON = (val) => {
        if (val == null) return null;
        if (typeof val === "object") return val;
        if (typeof val === "string") {
            const s = val.trim();
            if (!s) return "";
            try {
                return JSON.parse(s);
            } catch {
                return s;
            }
        }
        return val;
    };

    const hasContent = (v) => {
        if (v == null) return false;
        if (typeof v === "string") return v.trim().length > 0 && v.trim() !== "{}" && v.trim() !== "[]";
        if (Array.isArray(v)) return v.length > 0;
        if (typeof v === "object") return Object.keys(v).length > 0;
        return !!v;
    };


// м’яко парсимо JSON-рядки, якщо це "[...]" або "{...}"
    const coerceJSON = (v) => {
        if (v == null) return "";
        if (typeof v !== "string") return v;
        const s = v.trim();
        if ((s.startsWith("[") && s.endsWith("]")) || (s.startsWith("{") && s.endsWith("}"))) {
            try {
                return JSON.parse(s);
            } catch {
                return v;
            }
        }
        return v;
    };


// ── ДОДАТИ: вибір полів для live / prematch
// Підхоплює правильні поля для LIVE / Prematch і м’яко парсить JSON-рядки
    const pickBetFields = (bet) => {
        const isLive =
            bet.bet_type === "live" ||
            bet.type === "live" ||
            !!bet.live_top3_bets ||
            !!bet.live_opinion;

        const rawOpinion = isLive
            ? (bet.live_opinion ?? bet.opinion ?? "")
            : (bet.opinion ?? bet.live_opinion ?? "");

        const rawTop3 = isLive
            ? (bet.live_top3_bets ?? bet.top3_bets ?? "")
            : (bet.top3_bets ?? bet.live_top3_bets ?? "");

        return {
            isLive,
            opinion: coerceJSON(rawOpinion),
            top3: coerceJSON(rawTop3),
            stats: bet.statistics ?? bet.stats ?? null,
            last: bet.last_matches ?? bet.last ?? undefined,
        };
    };


    useEffect(() => {
        // при зміні фільтра – згортаємо всі розкриті картки
        setExpandedMatches({});
        setExpandedLiveUsers({});
        setExpandedPrematch({});
        setPageSize(50);
    }, [selectedDate]);


    useEffect(() => {
        if (userLoading) return;

        if (!user) {
            navigate("/");
            return;
        }
        if (user.role !== "admin") {
            navigate("/");
            return;
        }

        const ctrl = new AbortController();
        const headers = {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
            "Expires": "0",
            "X-Telegram-Init-Data": getInitDataSafe(),
        };

        const adminId = user.telegram_id;

        const fetchUsers = async () => {
            try {
                const API_BASE = process.env.REACT_APP_API_BASE || '/api';
                const res = await axios.get(
                    `${API_BASE}/users?telegram_id=${adminId}&_=${Date.now()}`,
                    {headers, signal: ctrl.signal}
                );
                if (!res.data?.users) throw new Error("Invalid users data from server");
                const filtered = res.data.users.filter((u) => u.telegram_id !== adminId);
                setUsers(filtered);
                setLoading(false);
            } catch (err) {
                if (axios.isCancel?.(err)) return;
                console.error("Error fetching users:", err.response ? err.response.data : err.message);
                setError("Не вдалося отримати список користувачів. Спробуйте ще раз.");
                setLoading(false);
            }
        };

        fetchUsers();

        return () => ctrl.abort();
    }, [user, userLoading, navigate]);

    const normalizeAdminBet = useCallback((b) => {
        const dateKey = toIsoDateKey(b.date) || toIsoDateKey(b.generated_time);
        return {
            ...b,
            date: b.date ?? "",
            generated_time: b.generated_time ?? "",
            dateKey,
        };
    }, []);

    const loadAdminBetsPage = useCallback(async ({reset = false} = {}) => {
        if (!user?.telegram_id || betsLoading) return;
        const headers = {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
            "Expires": "0",
            "X-Telegram-Init-Data": getInitDataSafe(),
        };

        const offset = reset ? 0 : betsOffset;
        setBetsLoading(true);
        try {
            const API_BASE = process.env.REACT_APP_API_BASE || '/api';
            const res = await axios.get(
                `${API_BASE}/admin/bets_history?telegram_id=${user.telegram_id}&limit=${ADMIN_BETS_PAGE_LIMIT}&offset=${offset}&_=${Date.now()}`,
                {headers}
            );
            if (!res.data?.bets) throw new Error("Invalid bets data from server");

            const nextBets = res.data.bets.map(normalizeAdminBet);
            setBets((prev) => reset ? nextBets : [...prev, ...nextBets]);
            setBetsOffset(offset + nextBets.length);
            setBetsTotal(Number(res.data.total || offset + nextBets.length));
            setBetsHasMore(!!res.data.has_more);
        } catch (err) {
            console.error("Error fetching bets:", err.response ? err.response.data : err.message);
            setError("Не вдалося отримати список ставок. Спробуйте ще раз.");
        } finally {
            setBetsLoading(false);
        }
    }, [betsLoading, betsOffset, normalizeAdminBet, user?.telegram_id]);

    useEffect(() => {
        if (userLoading || !user || user.role !== "admin") return;
        if (activeTab !== "bets" && activeTab !== "stats") return;
        if (bets.length > 0 || betsLoading) return;
        loadAdminBetsPage({reset: true});
    }, [activeTab, user, userLoading, bets.length, betsLoading, loadAdminBetsPage]);

    useEffect(() => {
        if (userLoading || !user || user.role !== "admin") return;
        if (activeTab !== "schedule") return;
        if (schedules.length > 0) return;

        fetchSchedules();
    }, [activeTab, user, userLoading, schedules.length]);

    useEffect(() => {
        if (userLoading || !user || user.role !== "admin") return;
        if (activeTab !== "bonuses") return;
        if (referralRequests.length > 0 || shopPurchases.length > 0) return;

        fetchBonuses();
    }, [activeTab, user, userLoading, referralRequests.length, shopPurchases.length]);

    useEffect(() => {
        if (userLoading || !user || user.role !== "admin") return;
        if (activeTab !== "settings") return;
        fetchAdminSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, user, userLoading]);

    useEffect(() => {
        if (userLoading || !user || user.role !== "admin") return;
        if (activeTab !== "broadcast") return;
        if (users.length > 0) return;

        const ctrl = new AbortController();
        const headers = {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
            "Expires": "0",
            "X-Telegram-Init-Data": getInitDataSafe(),
        };

        const fetchUsers = async () => {
            try {
                const API_BASE = process.env.REACT_APP_API_BASE || '/api';
                const res = await axios.get(
                    `${API_BASE}/users?telegram_id=${user.telegram_id}&_=${Date.now()}`,
                    {headers, signal: ctrl.signal}
                );
                if (!res.data?.users) throw new Error("Invalid users data from server");
                const filtered = res.data.users.filter((u) => u.telegram_id !== user.telegram_id);
                setUsers(filtered);
            } catch (err) {
                if (axios.isCancel?.(err)) return;
                console.error("Error fetching users:", err.response ? err.response.data : err.message);
                setError("Не вдалося отримати список користувачів. Спробуйте ще раз.");
            }
        };

        fetchUsers();
        return () => ctrl.abort();
    }, [activeTab, user, userLoading, users.length]);

    useEffect(() => {
        if (userLoading || !user || user.role !== "admin") return;
        if (activeTab !== "users") return;
        if (channelAudit) return;
        fetchChannelAudit(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, user, userLoading, channelAudit]);

    useEffect(() => {
        if (userLoading || !user || user.role !== "admin") return;
        fetchAccessRequests();
    }, [user, userLoading, fetchAccessRequests]);

    // Telegram Mini App: не дозволяємо "свайпом" згорнути/закрити під час скролу (Bot API 7.7+)
    useEffect(() => {
        const tg = window?.Telegram?.WebApp;
        try {
            tg?.expand?.();
            tg?.disableVerticalSwipes?.();
        } catch {
        }
        return () => {
            try {
                tg?.enableVerticalSwipes?.();
            } catch {
            }
        };
    }, []);

    // cleanup object URL for schedule photo preview
    useEffect(() => {
        return () => {
            try {
                if (schedPreviewUrl) URL.revokeObjectURL(schedPreviewUrl);
            } catch {
            }
        };
    }, [schedPreviewUrl]);


    const handleUpdateUser = async (telegram_id, updateData) => {
        try {
            const API_BASE = process.env.REACT_APP_API_BASE || '/api';
            const res = await axios.post(
                `${API_BASE}/user/${telegram_id}/update?requester_id=${user.telegram_id}`,
                updateData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        "Pragma": "no-cache",
                        "Expires": "0",
                        "X-Telegram-Init-Data": getInitDataSafe(),

                    },
                }
            );
            setUsers((prevUsers) =>
                prevUsers.map((u) =>
                    u.telegram_id === telegram_id ? {...u, ...updateData} : u
                )
            );
            alert(res.data.message);
            return res.data;
        } catch (err) {
            console.error("Error updating user:", err.response ? err.response.data : err.message);
            alert("Помилка: " + (err.response?.data?.detail || err.message));
            return null;
        }
    };

    const revokeAccessForAllUsers = async () => {
        if (!user?.telegram_id) return;
        const confirmed = window.confirm(
            "Забрати доступ у всіх користувачів, крім адмінів?\n\nЦе потрібно для повної переобробки доступів. Дію можна буде відкотити тільки вручну."
        );
        if (!confirmed) return;

        try {
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const res = await axios.post(
                `${API_BASE}/admin/users/revoke-all-access?telegram_id=${user.telegram_id}`,
                {},
                {headers}
            );
            const revokedIds = new Set(safeArray(res.data?.telegram_ids).map((id) => String(id)));
            setUsers((prev) => safeArray(prev).map((u) => (
                revokedIds.has(String(u.telegram_id)) ? {...u, has_access: false} : u
            )));
            alert(`Доступ забрано: ${res.data?.revoked || 0}`);
        } catch (err) {
            console.error("revokeAccessForAllUsers error:", err.response ? err.response.data : err.message);
            alert("Помилка: " + (err.response?.data?.detail || err.message));
        }
    };

    const clearAllExternalIdLinks = async () => {
        if (!user?.telegram_id) return;
        const confirmed = window.confirm(
            "Очистити всі прив'язки зовнішніх ID?\n\nДоступ користувачів це не забере, але всі старі ID будуть відв'язані."
        );
        if (!confirmed) return;

        try {
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const res = await axios.post(
                `${API_BASE}/admin/external-id/clear-links?telegram_id=${user.telegram_id}`,
                {},
                {headers}
            );
            setUsers((prev) => safeArray(prev).map((u) => ({...u, external_id: ""})));
            setAffiliateProfile((prev) => prev?.user ? {...prev, link: null} : prev);
            alert(`Прив'язки очищено: ${res.data?.deleted || 0}`);
        } catch (err) {
            console.error("clearAllExternalIdLinks error:", err.response ? err.response.data : err.message);
            alert("Помилка: " + (err.response?.data?.detail || err.message));
        }
    };

    const handleDeleteBet = async (matchName, betDate) => {  // Додаємо betDate
        try {
            const safeDate = toIsoDateKey(betDate); // НОРМАЛІЗАЦІЯ betDate
            const API_BASE = process.env.REACT_APP_API_BASE || '/api';
            const res = await axios.delete(
                `${API_BASE}/bets/${encodeURIComponent(matchName)}/delete?date=${safeDate}&telegram_id=${user.telegram_id}`,
                {
                    headers: {
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        "Pragma": "no-cache",
                        "Expires": "0",
                        "X-Telegram-Init-Data": getInitDataSafe(),

                    },
                }
            );
            setBets((prevBets) => prevBets.filter((bet) => bet.matchName !== matchName));
            alert(res.data.message);
        } catch (err) {
            console.error("Error deleting bet:", err.response ? err.response.data : err.message);
            alert("Помилка: " + (err.response?.data?.detail || err.message));
        }
    };

    const handleSendBroadcast = async () => {
        try {
            setBroadcastStatus("");

            const text = (broadcastText || "").trim();
            if (!text) {
                alert("Введи повідомлення");
                return;
            }

            if (broadcastTarget === "user" && !broadcastUserId) {
                alert("Оберіть користувача");
                return;
            }

            setBroadcastSending(true);

            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const fd = new FormData();
            fd.append("requester_id", String(user.telegram_id));
            fd.append("target", broadcastTarget);
            fd.append("text", text);

            if (broadcastTarget === "user") {
                fd.append("target_user_id", String(broadcastUserId));
            }
            if (broadcastPhotos.length > 0) {
                broadcastPhotos.forEach((file) => {
                    fd.append("photos", file);
                });
            }

            const res = await axios.post(`${API_BASE}/admin/broadcast`, fd, {
                headers: {
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    "Pragma": "no-cache",
                    "Expires": "0",
                    "X-Telegram-Init-Data": getInitDataSafe(),
                },
            });

            const sent = res?.data?.sent ?? 0;
            const failed = res?.data?.failed ?? 0;
            setBroadcastStatus(`Готово. Надіслано: ${sent}. Помилок: ${failed}.`);
        } catch (err) {
            console.error("Broadcast error:", err.response ? err.response.data : err.message);
            const msg = err.response?.data?.detail || err.message || "Помилка розсилки";
            setBroadcastStatus(`Помилка: ${msg}`);
            alert(`Помилка: ${msg}`);
        } finally {
            setBroadcastSending(false);
        }
    };

    const fetchSchedules = async () => {
        try {
            setSchedStatus("");
            setSchedLoading(true);

            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };

            const res = await axios.get(
                `${API_BASE}/admin/scheduled_broadcasts?telegram_id=${user.telegram_id}&_=${Date.now()}`,
                {headers}
            );

            setSchedules(res?.data?.items || []);
        } catch (err) {
            console.error("fetchSchedules error:", err.response ? err.response.data : err.message);
            setSchedStatus("Не вдалося отримати список запланованих повідомлень");
        } finally {
            setSchedLoading(false);
        }
    };

    const fetchBonuses = async () => {
        try {
            setBonusStatus("");
            setBonusLoading(true);
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const [refsRes, shopRes] = await Promise.all([
                axios.get(`${API_BASE}/admin/referral-requests?telegram_id=${user.telegram_id}&status=pending&_=${Date.now()}`, {headers}),
                axios.get(`${API_BASE}/admin/shop-purchases?telegram_id=${user.telegram_id}&status=pending&_=${Date.now()}`, {headers}),
            ]);
            setReferralRequests(refsRes.data.items || []);
            setShopPurchases(shopRes.data.items || []);
        } catch (err) {
            console.error("fetchBonuses error:", err.response ? err.response.data : err.message);
            setBonusStatus("Не вдалося отримати бонусні заявки");
        } finally {
            setBonusLoading(false);
        }
    };

    const fetchAdminSettings = async () => {
        try {
            setSettingsStatus("");
            setSettingsLoading(true);
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const res = await axios.get(
                `${API_BASE}/admin/settings?telegram_id=${user.telegram_id}&_=${Date.now()}`,
                {headers}
            );
            setAdminSettings({...DEFAULT_ADMIN_SETTINGS, ...(res.data?.settings || {})});
        } catch (err) {
            console.error("fetchAdminSettings error:", err.response ? err.response.data : err.message);
            setSettingsStatus("Не вдалося завантажити налаштування");
        } finally {
            setSettingsLoading(false);
        }
    };

    const updateSettingField = (key, value) => {
        setAdminSettings((prev) => ({...prev, [key]: value}));
    };

    const saveAdminSettings = async () => {
        try {
            setSettingsSaving(true);
            setSettingsStatus("");
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const res = await axios.post(
                `${API_BASE}/admin/settings?telegram_id=${user.telegram_id}`,
                adminSettings,
                {headers}
            );
            setAdminSettings({...DEFAULT_ADMIN_SETTINGS, ...(res.data?.settings || {})});
            setSettingsStatus("Налаштування збережено ✅");
        } catch (err) {
            console.error("saveAdminSettings error:", err.response ? err.response.data : err.message);
            const msg = err.response?.data?.detail || err.message || "Помилка збереження";
            setSettingsStatus(`Помилка: ${msg}`);
            alert(`Помилка: ${msg}`);
        } finally {
            setSettingsSaving(false);
        }
    };

    const fetchChannelAudit = async (sync = false) => {
        if (!user?.telegram_id) return;
        try {
            setChannelAuditLoading(true);
            setChannelAuditStatus(sync ? "Перевіряю учасників каналу…" : "");
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const res = await axios.get(
                `${API_BASE}/admin/channel-access-audit?telegram_id=${user.telegram_id}&sync=${sync ? "true" : "false"}&_=${Date.now()}`,
                {headers}
            );
            setChannelAudit(res.data || null);
            if (!res.data?.configured) {
                setChannelAuditStatus(res.data?.message || "Вкажи ID каналу в налаштуваннях");
            } else if (sync && res.data?.sync) {
                setChannelAuditStatus(`Перевірено: ${res.data.sync.checked}, помилок: ${res.data.sync.failed}`);
            } else {
                setChannelAuditStatus("");
            }
        } catch (err) {
            console.error("fetchChannelAudit error:", err.response ? err.response.data : err.message);
            setChannelAuditStatus(`Помилка перевірки каналу: ${err.response?.data?.detail || err.message}`);
        } finally {
            setChannelAuditLoading(false);
        }
    };

    const revokeAccessForUsersNotInChannel = async () => {
        const targets = safeArray(channelAudit?.audit?.access_not_in_channel);
        if (!targets.length || !user?.telegram_id) return;
        const confirmed = window.confirm(
            `Забрати доступ у ${targets.length} користувачів, які мають доступ до бота, але не знайдені в каналі?\n\nАдмінів ця дія не зачіпає.`
        );
        if (!confirmed) return;

        try {
            setChannelAuditLoading(true);
            setChannelAuditStatus("Забираю доступ у юзерів не з каналу…");
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const res = await axios.post(
                `${API_BASE}/admin/channel-access-audit/revoke-access?telegram_id=${user.telegram_id}`,
                {},
                {headers}
            );
            const revokedIds = new Set(safeArray(res.data?.telegram_ids).map((id) => String(id)));
            if (revokedIds.size) {
                setUsers((prev) => safeArray(prev).map((u) => (
                    revokedIds.has(String(u.telegram_id)) ? {...u, has_access: false} : u
                )));
            }
            setChannelAuditStatus(`Доступ забрано: ${res.data?.revoked || 0}`);
            await fetchChannelAudit(false);
        } catch (err) {
            console.error("revokeAccessForUsersNotInChannel error:", err.response ? err.response.data : err.message);
            setChannelAuditStatus(`Помилка зняття доступу: ${err.response?.data?.detail || err.message}`);
        } finally {
            setChannelAuditLoading(false);
        }
    };

    const fetchAffiliateProfile = async (queryValue = affiliateQuery) => {
        const query = String(queryValue || "").trim();
        if (!query || !user?.telegram_id) {
            setAffiliateStatus("Введи Telegram ID, @нік або зовнішній ID");
            return;
        }
        try {
            setAffiliateLoading(true);
            setAffiliateStatus("");
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const res = await axios.get(
                `${API_BASE}/admin/external-id/profile?telegram_id=${user.telegram_id}&q=${encodeURIComponent(query)}&_=${Date.now()}`,
                {headers}
            );
            setAffiliateProfile(res.data || null);
            if (!res.data?.user && !res.data?.link) {
                setAffiliateStatus("Нічого не знайшов за цим значенням");
            }
        } catch (err) {
            console.error("fetchAffiliateProfile error:", err.response ? err.response.data : err.message);
            setAffiliateStatus(`Помилка: ${err.response?.data?.detail || err.message}`);
        } finally {
            setAffiliateLoading(false);
        }
    };

    const linkAffiliateUser = async () => {
        const telegramIdentity = String(affiliateLinkTelegramId || "").trim();
        const cid = String(affiliateLinkCid || "").trim();
        if (!telegramIdentity || !cid || !user?.telegram_id) {
            setAffiliateStatus("Вкажи Telegram ID або @нік і зовнішній ID");
            return;
        }
        try {
            setAffiliateLoading(true);
            setAffiliateStatus("");
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            const res = await axios.post(
                `${API_BASE}/admin/external-id/link?telegram_id=${user.telegram_id}`,
                {
                    ...( /^\d+$/.test(telegramIdentity)
                        ? {telegram_id: Number(telegramIdentity)}
                        : {telegram_username: telegramIdentity.replace(/^@/, "")}
                    ),
                    external_id: cid,
                    note: affiliateLinkNote,
                },
                {headers}
            );
            setAffiliateProfile(res.data?.profile || null);
            setAffiliateQuery(String(res.data?.profile?.telegram_id || telegramIdentity));
            setAffiliateStatus("Зв'язку збережено ✅");
            setAffiliateLinkNote("");
            setUsers((prev) => safeArray(prev).map((u) => (
                String(u.telegram_id) === String(res.data?.profile?.user?.telegram_id || telegramIdentity)
                    ? {...u, external_id: cid}
                    : u
            )));
        } catch (err) {
            console.error("linkAffiliateUser error:", err.response ? err.response.data : err.message);
            setAffiliateStatus(`Помилка прив'язки: ${err.response?.data?.detail || err.message}`);
        } finally {
            setAffiliateLoading(false);
        }
    };

    const processReferral = async (requestId, status, rewardPoints) => {
        try {
            setBonusStatus("");
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            await axios.post(
                `${API_BASE}/admin/referral-requests/${requestId}/process?telegram_id=${user.telegram_id}`,
                {status, reward_points: rewardPoints},
                {headers}
            );
            setBonusStatus(status === "approved" ? "Бали нараховано ✅" : "Заявку відхилено");
            await fetchBonuses();
        } catch (err) {
            const msg = err.response?.data?.detail || err.message || "Помилка обробки";
            setBonusStatus(`Помилка: ${msg}`);
            alert(`Помилка: ${msg}`);
        }
    };

    const processShopPurchase = async (purchaseId, status) => {
        try {
            setBonusStatus("");
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };
            await axios.post(
                `${API_BASE}/admin/shop-purchases/${purchaseId}/process?telegram_id=${user.telegram_id}`,
                {status},
                {headers}
            );
            setBonusStatus(status === "completed" ? "Покупку закрито ✅" : "Покупку скасовано, бали повернено");
            await fetchBonuses();
        } catch (err) {
            const msg = err.response?.data?.detail || err.message || "Помилка обробки покупки";
            setBonusStatus(`Помилка: ${msg}`);
            alert(`Помилка: ${msg}`);
        }
    };

    const resetScheduleForm = () => {
        setSchedEditId(null);
        setSchedTitle("");
        setSchedEnabled(true);
        setSchedTarget("access");
        setSchedTime("10:00");
        setSchedMinMatches("");
        setSchedTemplate("Привіт, {{first_name}}! Сьогодні {{matches_today}} матчів ({{weekday_today}}).\n{{no_bet_text}}");
        setSchedStatus("");
        setSchedPhoto(null);
    };

    const startEditSchedule = (s) => {
        setSchedEditId(s.id);
        setSchedTitle(s.title || "");
        setSchedEnabled(!!s.enabled);
        setSchedTarget((s.target || "access").toLowerCase());
        setSchedTime(s.send_time || "10:00");
        setSchedMinMatches(s.min_matches == null ? "" : String(s.min_matches));
        setSchedTemplate(s.text_template || "");
        setSchedStatus("");
        setSchedPhoto(null);
    };

    const saveSchedule = async () => {
        try {
            setSchedStatus("");

            const t = (schedTime || "").trim();
            if (!/^\d{2}:\d{2}$/.test(t)) {
                alert("Час має бути у форматі HH:MM");
                return;
            }
            if (!schedTemplate.trim()) {
                alert("Шаблон не може бути порожнім");
                return;
            }
            if (schedTarget !== "all" && schedTarget !== "access") {
                alert("Невірний target");
                return;
            }

            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };

            const fd = new FormData();
            fd.append("telegram_id", String(user.telegram_id));
            fd.append("title", schedTitle);
            fd.append("enabled", schedEnabled ? "1" : "0");
            fd.append("target", schedTarget);
            fd.append("send_time", t);
            if (schedMinMatches.trim() !== "") fd.append("min_matches", schedMinMatches.trim());
            fd.append("text_template", schedTemplate);
            if (schedPhoto) fd.append("photo", schedPhoto);

            if (schedEditId) {
                await axios.put(`${API_BASE}/admin/scheduled_broadcasts/${schedEditId}`, fd, {headers});
                setSchedStatus("Оновлено ✅");
            } else {
                await axios.post(`${API_BASE}/admin/scheduled_broadcasts`, fd, {headers});
                setSchedStatus("Створено ✅");
            }

            await fetchSchedules();
        } catch (err) {
            console.error("saveSchedule error:", err.response ? err.response.data : err.message);
            const msg = err.response?.data?.detail || err.message || "Помилка збереження";
            setSchedStatus(`Помилка: ${msg}`);
            alert(`Помилка: ${msg}`);
        }
    };

    const deleteSchedule = async (id) => {
        try {
            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };

            await axios.delete(`${API_BASE}/admin/scheduled_broadcasts/${id}?telegram_id=${user.telegram_id}`, {headers});
            setSchedStatus("Видалено ✅");
            await fetchSchedules();
        } catch (err) {
            console.error("deleteSchedule error:", err.response ? err.response.data : err.message);
            const msg = err.response?.data?.detail || err.message || "Помилка видалення";
            setSchedStatus(`Помилка: ${msg}`);
            alert(`Помилка: ${msg}`);
        }
    };

    const openSchedulePhotoPreview = async (s) => {
        try {
            if (schedPreviewUrl) {
                URL.revokeObjectURL(schedPreviewUrl);
                setSchedPreviewUrl(null);
            }

            const API_BASE = process.env.REACT_APP_API_BASE || "/api";
            const headers = {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
                "X-Telegram-Init-Data": getInitDataSafe(),
            };

            const res = await axios.get(
                `${API_BASE}/admin/scheduled_broadcasts/${s.id}/photo?telegram_id=${user.telegram_id}&_=${Date.now()}`,
                {headers, responseType: "blob"}
            );

            const blobUrl = URL.createObjectURL(res.data);
            setSchedPreviewTitle(s.title || `#${s.id}`);
            setSchedPreviewUrl(blobUrl);
            setSchedPreviewOpen(true);
        } catch (err) {
            let detail = "";
            const status = err?.response?.status;

            try {
                // when responseType is "blob", backend error body may still be JSON/text but arrives as Blob
                const data = err?.response?.data;
                if (data && typeof data.text === "function") {
                    const txt = await data.text();
                    detail = txt;
                } else if (typeof data === "string") {
                    detail = data;
                } else if (data && typeof data === "object") {
                    detail = JSON.stringify(data);
                }
            } catch {
            }

            console.error("openSchedulePhotoPreview error:", status, detail || (err?.message || ""));

            if (status === 404) {
                alert("Фото не знайдено (можливо, воно не прикріплене до цього запланованого повідомлення)");
            } else if (status === 403) {
                alert("Доступ заборонено (403). Перевір авторизацію адміна/Telegram initData");
            } else {
                alert(`Не вдалося завантажити фото${status ? ` (HTTP ${status})` : ""}${detail ? `: ${detail}` : ""}`);
            }
        }
    };

    const closeSchedulePhotoPreview = () => {
        try {
            if (schedPreviewUrl) URL.revokeObjectURL(schedPreviewUrl);
        } catch {
        }
        setSchedPreviewUrl(null);
        setSchedPreviewOpen(false);
        setSchedPreviewTitle("");
    };

    const handleGrantAccess = async (telegram_id) => {
        const result = await handleUpdateUser(telegram_id, {has_access: true});
        if (result && activeTab === "users" && channelAudit) {
            fetchChannelAudit(false);
        }
    };

    const handleRevokeAccess = (telegram_id) => {
        handleUpdateUser(telegram_id, {has_access: false});
    };

    const handleGrantAdmin = async (targetUser) => {
        const telegramId = targetUser?.telegram_id;
        if (!telegramId) return;
        const label = `${targetUser.first_name || targetUser.username || "Користувач"} (${telegramId})`;
        const confirmed = window.confirm(
            `Точно створити заявку на видачу адмінки для ${label}?\n\nПісля цього бот надішле тобі ще одне підтвердження в Telegram.`
        );
        if (!confirmed) return;

        try {
            const API_BASE = process.env.REACT_APP_API_BASE || '/api';
            const res = await axios.post(
                `${API_BASE}/admin/users/${telegramId}/admin-grant-request?telegram_id=${user.telegram_id}`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        "Pragma": "no-cache",
                        "Expires": "0",
                        "X-Telegram-Init-Data": getInitDataSafe(),
                    },
                }
            );
            alert((res.data?.message || "Надіслав підтвердження в Telegram.") + "\n\nПісля підтвердження онови список користувачів.");
        } catch (err) {
            console.error("Error requesting admin grant:", err.response ? err.response.data : err.message);
            alert("Помилка: " + (err.response?.data?.detail || err.message));
        }
    };

    const handleRevokeAdmin = (telegram_id) => {
        handleUpdateUser(telegram_id, {role: "user"});
    };

    const toggleMatchExpansion = (matchKey) => {
        setExpandedMatches((prev) => ({
            ...prev,
            [matchKey]: !prev[matchKey],
        }));
    };

    const togglePrematchExpansion = (matchKey) => {
        setExpandedPrematch((prev) => ({
            ...prev,
            [matchKey]: !prev[matchKey],
        }));
    };

    const toggleLiveUserExpansion = (matchKey, telegramId) => {
        const key = `${matchKey}__${telegramId || ""}`;
        setExpandedLiveUsers((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    // унікальний ключ: матч + дата

    const fmtUser = (b) => (b.username ? `@${b.username}` : (b.fullname || `id:${b.telegram_id}`));
    const fmtUserLabel = (u) => {
        const uname = u?.username ? `@${u.username}` : "";
        const full = `${u?.first_name || ""} ${u?.last_name || ""}`.trim();
        const base = uname || full || `id:${u?.telegram_id}`;
        const tags = [];
        if (u?.has_access) tags.push("access");
        if ((u?.role || "").toLowerCase() === "admin") tags.push("admin");
        return tags.length ? `${base} · ${tags.join(" · ")}` : base;
    };
    const fmtAuditPerson = (u) => {
        const username = u?.username ? `@${u.username}` : "";
        const full = `${u?.first_name || ""} ${u?.last_name || ""}`.trim();
        return username || full || `id:${u?.telegram_id || "—"}`;
    };
    const fmtBetsCount = (count) => {
        const n = Math.abs(Number(count || 0));
        const lastTwo = n % 100;
        const last = n % 10;
        if (lastTwo >= 11 && lastTwo <= 14) return `${n} ставок`;
        if (last === 1) return `${n} ставка`;
        if (last >= 2 && last <= 4) return `${n} ставки`;
        return `${n} ставок`;
    };
    const fmtReferralPerson = (item, prefix = "invited") => {
        const username = item?.[`${prefix}_username`];
        if (username) return `@${username}`;
        const full = `${item?.[`${prefix}_first_name`] || ""} ${item?.[`${prefix}_last_name`] || ""}`.trim();
        return full || `id:${item?.[`${prefix}_telegram_id`] || "—"}`;
    };
    const formatReferralStatus = (status) => {
        if (status === "approved") return "підтверджено";
        if (status === "rejected") return "відхилено";
        return "очікує";
    };
    const affiliateUserTitle = (u) => {
        if (!u) return "Не прив'язаний до Telegram юзера";
        const username = u.username ? `@${u.username}` : "";
        const full = `${u.first_name || ""} ${u.last_name || ""}`.trim();
        return username || full || `TG ${u.telegram_id}`;
    };
    const affiliateProfileUrl = (u) => {
        if (!u) return "";
        return u.username ? `https://t.me/${u.username}` : `tg://user?id=${u.telegram_id}`;
    };
    const makeBetKey = (b) => `${b.matchName || ""}__${b.date || ""}__${b.generated_time || ""}__${b.telegram_id || ""}`;

    // Групуємо ставки по матчах: спочатку показуємо матчі, а всередині — користувачів зі ставками
    const groupedMatches = useMemo(() => {
        const arr = visibleBets || [];
        const map = new Map();

        const getMatchKey = (b) => {
            const fid = b?.fixture_id != null ? String(b.fixture_id) : "";
            const name = (b?.matchName || "").trim();
            const dateKey = (b?.dateKey || "").trim();
            // якщо є fixture_id — він надійніший
            const base = fid || name || "(unknown)";
            return `${base}__${dateKey}`;
        };

        for (const b of arr) {
            const key = getMatchKey(b);
            if (!map.has(key)) {
                map.set(key, {
                    matchKey: key,
                    fixture_id: b?.fixture_id,
                    matchName: b?.matchName || "(без назви матчу)",
                    dateKey: b?.dateKey || "",
                    items: [],
                });
            }
            map.get(key).items.push(b);
        }

        const groups = Array.from(map.values());

        // Сортуємо матчі за найсвіжішою ставкою всередині
        groups.sort((ga, gb) => {
            const ta = Math.max(...(ga.items || []).map((x) => Date.parse(x.generated_time || 0) || 0), 0);
            const tb = Math.max(...(gb.items || []).map((x) => Date.parse(x.generated_time || 0) || 0), 0);
            return tb - ta;
        });

        return groups;
    }, [visibleBets]);

    // нормалізація значення ставки (щоб коректно рахувати "унікальні ставки")
    const normBetVal = (v) => {
        const val = coerceJSON(v);
        if (val == null) return "";
        if (Array.isArray(val) || typeof val === "object") {
            try {
                return JSON.stringify(val);
            } catch {
                return String(val);
            }
        }
        return String(val).trim();
    };

// Статистика по днях: матчі / унікальні ставки / унікальні користувачі / % залученості
// Залученість: (кількість унікальних людей, що робили ставку у цей день) / (загальна кількість користувачів з доступом) * 100
    const dailyStats = useMemo(() => {
        const map = new Map();
        const all = bets || [];

        const getMatchBase = (b) => {
            const fid = b?.fixture_id != null ? String(b.fixture_id) : "";
            const name = (b?.matchName || "").trim();
            return fid || name || "(unknown)";
        };

        for (const b of all) {
            const d = (b?.dateKey || "").trim();
            if (!d) continue;

            if (!map.has(d)) {
                map.set(d, {
                    dateKey: d,
                    matchSet: new Set(),
                    usersSet: new Set(),
                    betsSet: new Set(),
                });
            }

            const row = map.get(d);
            const matchBase = getMatchBase(b);
            row.matchSet.add(matchBase);

            if (b?.telegram_id != null) row.usersSet.add(String(b.telegram_id));

            const f = pickBetFields(b);
            const betVal = normBetVal(f.top3);

            // унікальна ставка = матч + тип (live/prematch) + значення ставки
            const betKey = `${matchBase}__${f.isLive ? "live" : "prematch"}__${betVal}`;

            // якщо ставка порожня — не рахуємо як унікальну
            if (betVal) row.betsSet.add(betKey);
        }

        const totalEligibleUsers = (users || []).filter((u) => !!u.has_access).length;

        const rows = Array.from(map.values()).map((r) => {
            const matches = r.matchSet.size;
            const uniqueBets = r.betsSet.size;
            const engagedUsers = r.usersSet.size;
            const eff = totalEligibleUsers > 0 ? (engagedUsers / totalEligibleUsers) * 100 : 0;

            return {
                dateKey: r.dateKey,
                matches,
                uniqueBets,
                engagedUsers,
                totalEligibleUsers,
                efficiency: Math.round(eff * 10) / 10,
            };
        });

        // нові дати зверху
        rows.sort((a, b) => b.dateKey.localeCompare(a.dateKey));
        return rows;
    }, [bets, users]);

    if (userLoading || loading) return <p>Завантаження...</p>;
    if (error)
        return (
            <div>
                <p>{error}</p>
                <button onClick={() => window.location.reload()}>Спробувати ще раз</button>
            </div>
        );


// (опційно) красивий формат дати на кнопках
    const formatUADate = (iso) => {
        try {
            const d = new Date(iso + "T00:00:00");
            return d.toLocaleDateString("uk-UA", {day: "2-digit", month: "2-digit", year: "numeric"});
        } catch {
            return iso;
        }
    };


    const renderMaybeList = (data) => {
        const val = coerceJSON(data);
        if (val == null || val === "") return <em>—</em>;
        if (Array.isArray(val)) {
            return (
                <ul className={styles.betList}>
                    {val.map((x, i) => <li
                        key={i}>{typeof x === "string" ? x : JSON.stringify(x)}</li>)}
                </ul>
            );
        }
        if (typeof val === "object") {
            return <pre className={styles.preJSON}>{safeStringify(val, 2)}</pre>;
        }
        return <span>{String(val)}</span>;
    };


    return (
        <div className={styles.pageContainer}>
            <h1 className={styles.pageTitle}>Адмін панель</h1>
            <div className={styles.backButtonContainer}>
                <button
                    onClick={() => navigate(-1)}
                    className={styles.backButton}
                >
                    ← Назад
                </button>
            </div>
            <div className={styles.tabContainer}>
                <button
                    className={`${styles.tabButton} ${activeTab === "accessRequests" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("accessRequests")}
                >
                    Заявки{accessRequests.length > 0 ? ` · ${accessRequests.length}` : ""}
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "users" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("users")}
                >
                    Користувачі
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "bets" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("bets")}
                >
                    Ставки
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "stats" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("stats")}
                >
                    Статистика
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "broadcast" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("broadcast")}
                >
                    Розсилка
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "bonuses" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("bonuses")}
                >
                    Бонуси
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "affiliate" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("affiliate")}
                >
                    ID доступу
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "schedule" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("schedule")}
                >
                    Заплановано
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "settings" ? styles.activeTab : ""}`}
                    onClick={() => setActiveTab("settings")}
                >
                    Налаштування
                </button>
            </div>
            {activeTab === "accessRequests" && (
                <>
                    <div className={styles.accessRequestsHeader}>
                        <div>
                            <h2 className={styles.matchTitle}>Заявки на доступ</h2>
                            <p>Нові заявки зберігаються тут і більше не надсилаються окремими повідомленнями в Telegram.</p>
                        </div>
                        <button
                            type="button"
                            className={styles.beautifulButton}
                            onClick={fetchAccessRequests}
                            disabled={accessRequestsLoading}
                        >
                            {accessRequestsLoading ? "Оновлюю…" : "Оновити"}
                        </button>
                    </div>
                    <div className={styles.animatedGradient}></div>
                    {accessRequestsStatus && (
                        <div className={styles.accessRequestsStatus}>{accessRequestsStatus}</div>
                    )}
                    {!accessRequestsLoading && accessRequests.length === 0 ? (
                        <div className={styles.accessRequestsEmpty}>
                            Непідтверджених заявок зараз немає
                        </div>
                    ) : (
                        <div className={styles.accessRequestsGrid}>
                            {accessRequests.map((item) => {
                                const person = {
                                    telegram_id: item.telegram_id,
                                    username: item.username,
                                };
                                const fullName = [item.first_name, item.last_name].filter(Boolean).join(" ") || "Без імені";
                                const referrerName = item.referrer_username
                                    ? `@${item.referrer_username}`
                                    : [item.referrer_first_name, item.referrer_last_name].filter(Boolean).join(" ");
                                return (
                                    <article key={item.id} className={styles.accessRequestCard}>
                                        <div className={styles.accessRequestTopline}>
                                            <span>Заявка #{item.id}</span>
                                            <time>{formatKyivTime(item.created_at) || "—"}</time>
                                        </div>
                                        <a
                                            href={affiliateProfileUrl(person)}
                                            target="_blank"
                                            rel="noreferrer"
                                            className={styles.accessRequestPerson}
                                        >
                                            <strong>{fullName}</strong>
                                            <span>{item.username ? `@${item.username}` : "Telegram без username"}</span>
                                        </a>
                                        <div className={styles.accessRequestFacts}>
                                            <span><small>Telegram ID</small><strong>{item.telegram_id}</strong></span>
                                            <span><small>1win ID</small><strong>{item.external_id}</strong></span>
                                            <span><small>Ставок</small><strong>{item.total_bets || 0}</strong></span>
                                            <span><small>В боті з</small><strong>{formatKyivTime(item.user_created_at) || "—"}</strong></span>
                                        </div>
                                        {item.referrer_telegram_id && (
                                            <div className={styles.accessRequestReferral}>
                                                Запросив друг: {referrerName || "TG користувач"} · {item.referrer_telegram_id}
                                                <small>Після надання доступу створиться окрема заявка на 1500 балів.</small>
                                            </div>
                                        )}
                                        <div className={styles.accessRequestActions}>
                                            <button
                                                type="button"
                                                className={styles.accessApproveButton}
                                                onClick={() => decideAccessRequest(item.id, true)}
                                            >
                                                Дати доступ
                                            </button>
                                            <button
                                                type="button"
                                                className={styles.accessRejectButton}
                                                onClick={() => decideAccessRequest(item.id, false)}
                                            >
                                                Відхилити
                                            </button>
                                        </div>
                                    </article>
                                );
                            })}
                        </div>
                    )}
                </>
            )}
            {activeTab === "users" && (
                <>
                    <h2 className={styles.matchTitle}>Керування користувачами</h2>
                    <div className={styles.animatedGradient}></div>

                    {/* Фільтри користувачів */}
                    <div className={styles.dateFilterRow} style={{marginTop: 8, marginBottom: 12}}>
                        <button
                            type="button"
                            className={styles.beautifulButton}
                            onClick={revokeAccessForAllUsers}
                            style={{background: "#8f1d1d", color: "#fff"}}
                        >
                            Забрати доступ у всіх
                        </button>
                        <button
                            type="button"
                            className={`${styles.dateChip} ${userFilter === "access" ? styles.chipActive : ""}`}
                            onClick={() => setUserFilter("access")}
                        >
                            Є доступ
                        </button>
                        <button
                            type="button"
                            className={`${styles.dateChip} ${userFilter === "access_not_channel" ? styles.chipActive : ""}`}
                            onClick={() => setUserFilter("access_not_channel")}
                        >
                            Доступ є, не в каналі
                            {channelAudit?.audit?.access_not_in_channel?.length ? ` · ${channelAudit.audit.access_not_in_channel.length}` : ""}
                        </button>
                        <button
                            type="button"
                            className={`${styles.dateChip} ${userFilter === "channel_no_access" ? styles.chipActive : ""}`}
                            onClick={() => setUserFilter("channel_no_access")}
                        >
                            В каналі без доступу
                            {(channelAudit?.audit?.channel_without_bot_access || channelAudit?.audit?.channel_not_in_bot)?.length
                                ? ` · ${(channelAudit?.audit?.channel_without_bot_access || channelAudit?.audit?.channel_not_in_bot).length}`
                                : ""}
                        </button>
                        <button
                            type="button"
                            className={`${styles.dateChip} ${userFilter === "all" ? styles.chipActive : ""}`}
                            onClick={() => setUserFilter("all")}
                        >
                            Всі
                        </button>

                        {/* пошук по ніку/імені/ID */}
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Пошук: нік, ім'я, TG ID або зовнішній ID"
                            className={styles.searchInput}
                            style={{
                                marginLeft: 12,
                                flex: 1,
                                minWidth: 200,
                                padding: "8px 10px",
                                borderRadius: 8,
                                color: "#000"
                            }}
                        />
                    </div>

                    <div className={styles.referralAdminBox} style={{marginBottom: 14}}>
                        <strong>Аудит каналу Сім’я Грача</strong>
                        <span>
                            Відомих учасників каналу: {channelAudit?.audit?.known_channel_members || 0} ·
                            Юзерів з доступом: {channelAudit?.audit?.users_with_access || 0}
                        </span>
                        {channelAuditStatus && <em>{channelAuditStatus}</em>}
                        {channelAudit?.note && <em>{channelAudit.note}</em>}
                        <div className={styles.buttonGroup} style={{marginTop: 8}}>
                            <button
                                type="button"
                                className={styles.beautifulButton}
                                onClick={() => fetchChannelAudit(true)}
                                disabled={channelAuditLoading}
                            >
                                {channelAuditLoading ? "Перевіряю…" : "Оновити перевірку каналу"}
                            </button>
                        </div>

                        <div style={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 10, marginTop: 10}}>
                            <div>
                                <strong>Має доступ, але не в каналі</strong>
                                {safeArray(channelAudit?.audit?.access_not_in_channel).length > 0 ? (
                                    <>
                                        <ul>
                                            {safeArray(channelAudit?.audit?.access_not_in_channel).slice(0, 12).map((item) => (
                                                <li key={`not-channel-${item.telegram_id}`}>
                                                    {fmtAuditPerson(item)} · id:{item.telegram_id}
                                                </li>
                                            ))}
                                        </ul>
                                        <button
                                            type="button"
                                            className={styles.beautifulButton}
                                            onClick={revokeAccessForUsersNotInChannel}
                                            disabled={channelAuditLoading}
                                            style={{
                                                marginTop: 8,
                                                padding: "8px 12px",
                                                fontSize: 12,
                                                opacity: channelAuditLoading ? 0.7 : 1,
                                            }}
                                        >
                                            Забрати доступ у всіх зі списку
                                        </button>
                                    </>
                                ) : (
                                    <em>Поки таких не знайдено</em>
                                )}
                            </div>
                            <div>
                                <strong>В каналі, але без доступу до бота</strong>
                                {safeArray(channelAudit?.audit?.channel_without_bot_access || channelAudit?.audit?.channel_not_in_bot).length > 0 ? (
                                    <ul>
                                        {safeArray(channelAudit?.audit?.channel_without_bot_access || channelAudit?.audit?.channel_not_in_bot).slice(0, 12).map((item) => (
                                            <li key={`channel-no-access-${item.telegram_id}`} style={{marginBottom: 8}}>
                                                <div>
                                                    {fmtAuditPerson(item)} · id:{item.telegram_id}
                                                </div>
                                                <em>
                                                    {fmtBetsCount(item.total_bets)} · останній вхід: {formatKyivTime(item.last_login) || "немає"}
                                                </em>
                                                <button
                                                    type="button"
                                                    className={styles.beautifulButton}
                                                    onClick={() => handleGrantAccess(item.telegram_id)}
                                                    disabled={channelAuditLoading}
                                                    style={{
                                                        marginTop: 6,
                                                        padding: "7px 10px",
                                                        fontSize: 11,
                                                    }}
                                                >
                                                    Надати доступ
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <em>Поки таких не знайдено</em>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className={styles.buttonGroup}>
                        {visibleUsers.map((u) => (
                            <div key={u.telegram_id} className={styles.userBlock}>
                                <div className={styles.userInfo}>
                                    <p>
                                        <a
                                            href={affiliateProfileUrl(u)}
                                            target="_blank"
                                            rel="noreferrer"
                                            className={styles.affiliateLinkButton}
                                        >
                                            <strong>{u.first_name || u.username || "Користувач"} </strong>
                                            ({u.username ? `@${u.username}` : "нік невідомий"}, ID: {u.telegram_id})
                                        </a>
                                    </p>
                                    <p>Зовнішній ID: {u.external_id ? <strong>{u.external_id}</strong> : "не прив'язаний"}</p>
                                    <p>Доступ: {u.has_access ? "Є" : "Немає"}</p>
                                    <p>Роль: {u.role === "admin" ? "Адмін" : "Користувач"}</p>
                                    <p>Бали: {u.total_points || 0}</p>
                                    <p>Ставок згенеровано: {u.total_bets || 0}</p>
                                    <div className={styles.referralAdminBox}>
                                        <strong>Реферали</strong>
                                        <span>
                                            Очікує: {u.referrals?.pending || 0} · Підтв.: {u.referrals?.approved || 0} · Відх.: {u.referrals?.rejected || 0} · Зароблено: {u.referrals?.earned_points || 0}
                                        </span>
                                        {u.referrals?.invited_by && (
                                            <em>
                                                Привів: {fmtReferralPerson(u.referrals.invited_by, "referrer")} · {formatReferralStatus(u.referrals.invited_by.status)}
                                            </em>
                                        )}
                                        {(u.referrals?.items || []).length > 0 ? (
                                            <ul>
                                                {(u.referrals.items || []).slice(0, 4).map((ref) => (
                                                    <li key={ref.id}>
                                                        {fmtReferralPerson(ref, "invited")} · {formatReferralStatus(ref.status)} · {ref.reward_points} балів
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <em>Ще нікого не привів</em>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.userActions}>
                                    {u.has_access ? (
                                        <button
                                            className={styles.beautifulButton}
                                            onClick={() => handleRevokeAccess(u.telegram_id)}
                                        >
                                            Забрати доступ
                                        </button>
                                    ) : (
                                        <button
                                            className={styles.beautifulButton}
                                            onClick={() => handleGrantAccess(u.telegram_id)}
                                        >
                                            Надати доступ
                                        </button>
                                    )}
                                    {u.role === "admin" ? (
                                        <button
                                            className={styles.beautifulButton}
                                            onClick={() => handleRevokeAdmin(u.telegram_id)}
                                        >
                                            Зняти адмінку
                                        </button>
                                    ) : (
                                        <button
                                            className={styles.beautifulButton}
                                            onClick={() => handleGrantAdmin(u)}
                                        >
                                            Призначити адміном
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                        {filteredUsers.length > usersPageSize && (
                            <div style={{textAlign: "center", marginTop: 12}}>
                                <button
                                    type="button"
                                    className={styles.beautifulButton}
                                    onClick={() => setUsersPageSize((s) => s + 40)}
                                >
                                    Показати ще 40
                                </button>
                            </div>
                        )}
                    </div>
                </>
            )}
            {activeTab === "bets" && (
                <>
                    <h2 className={styles.matchTitle}>Список ставок</h2>
                    <div className={styles.animatedGradient}></div>
                    <div className={styles.dateFilterRow}>
                        <button
                            className={`${styles.dateChip} ${!selectedDate ? styles.chipActive : ""}`}
                            onClick={() => {
                                setSelectedDate("");
                                setShowAllDates(false);
                            }}
                        >
                            Усі дати
                        </button>

                        {(showAllDates ? availableDates : availableDates.slice(0, 8)).map((d) => (
                            <button
                                type="button"
                                key={d}
                                className={`${styles.dateChip} ${selectedDate === d ? styles.chipActive : ""}`}
                                onClick={() => setSelectedDate(d)}
                            >
                                {formatUADate(d)}
                            </button>
                        ))}

                        {availableDates.length > 8 && (
                            <button
                                type="button"
                                className={styles.dateChip}
                                onClick={() => setShowAllDates((v) => !v)}
                                style={{opacity: 0.9}}
                            >
                                {showAllDates ? "Згорнути" : `Ще ${availableDates.length - 8}`}
                            </button>
                        )}
                    </div>
                    <p style={{opacity: 0.78, margin: "4px 0 12px", fontSize: 13}}>
                        Завантажено {bets.length}{betsTotal ? ` з ${betsTotal}` : ""} ставок
                        {betsHasMore ? " · решту можна підвантажити нижче" : ""}
                    </p>
                    <div className={styles.buttonGroup}>
                        {betsLoading && bets.length === 0 ? (
                            <p>Завантажую ставки…</p>
                        ) : groupedMatches.length > 0 ? (
                            groupedMatches.slice(0, pageSize).map((group) => {
                                const items = group.items || [];
                                const prematch = items.filter((b) => {
                                    const f = pickBetFields(b);
                                    return !f.isLive;
                                });
                                const live = items.filter((b) => {
                                    const f = pickBetFields(b);
                                    return f.isLive;
                                });

                                return (
                                    <div key={group.matchKey} className={styles.betBlock}>
                                        <div
                                            className={styles.betTitle}
                                            onClick={() => toggleMatchExpansion(group.matchKey)}
                                        >
                                            <strong>{group.matchName || "(без назви матчу)"}</strong>
                                            <span className={styles.byUser}>
                                                · Prematch: {prematch.length} · LIVE: {live.length}
                                            </span>
                                        </div>

                                        {expandedMatches[group.matchKey] && (
                                            <div className={styles.betInfo}>
                                                {group.dateKey && (
                                                    <p>
                                                        <strong>Дата:</strong> {formatUADate(group.dateKey)}
                                                    </p>
                                                )}

                                                {/* Prematch */}
                                                <div style={{marginTop: 8}}>
                                                    <p><strong style={{color: 'red'}}>Prematch</strong></p>
                                                    {prematch.length === 0 ? (
                                                        <em>—</em>
                                                    ) : (() => {
                                                        // беремо найсвіжішу prematch ставку як «еталонну» (вона однакова для всіх)
                                                        const prematchSorted = prematch
                                                            .slice()
                                                            .sort((a, b) => (Date.parse(b.generated_time || 0) || 0) - (Date.parse(a.generated_time || 0) || 0));
                                                        const sample = prematchSorted[0];
                                                        const f = pickBetFields(sample);

                                                        // унікальні користувачі, через кому
                                                        const uniq = new Map();
                                                        prematchSorted.forEach((b) => {
                                                            const id = String(b.telegram_id || "");
                                                            if (!uniq.has(id)) uniq.set(id, fmtUser(b));
                                                        });
                                                        const usersLine = Array.from(uniq.values()).filter(Boolean).join(", ");

                                                        const isPrematchOpen = !!expandedPrematch[group.matchKey];

                                                        return (
                                                            <>
                                                                <p>
                                                                    <strong>Користувачі:</strong> {usersLine || "—"}
                                                                </p>

                                                                <button
                                                                    type="button"
                                                                    className={styles.beautifulButton}
                                                                    onClick={() => togglePrematchExpansion(group.matchKey)}
                                                                    style={{marginTop: 6}}
                                                                >
                                                                    {isPrematchOpen ? "Сховати" : "Показати"}
                                                                </button>

                                                                {isPrematchOpen && (
                                                                    hasContent(f.top3) ? (
                                                                        <div style={{marginTop: 6}}>
                                                                            <div>
                                                                                <strong
                                                                                    style={{color: 'red'}}>Ставка:</strong> {renderMaybeList(f.top3)}
                                                                            </div>
                                                                            {hasContent(f.opinion) && (
                                                                                <div>
                                                                                    <strong
                                                                                        style={{color: 'red'}}>Думка:</strong> {renderMaybeList(f.opinion)}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <em>—</em>
                                                                    )
                                                                )}
                                                            </>
                                                        );
                                                    })()}
                                                </div>

                                                {/* LIVE */}
                                                <div style={{marginTop: 12}}>
                                                    <p><strong style={{color: 'red'}}>LIVE</strong></p>
                                                    {live.length === 0 ? (
                                                        <em>—</em>
                                                    ) : (
                                                        <ul className={styles.betList}>
                                                            {live
                                                                .slice()
                                                                .sort((a, b) => (Date.parse(b.generated_time || 0) || 0) - (Date.parse(a.generated_time || 0) || 0))
                                                                .map((b, idx) => {
                                                                    const f = pickBetFields(b);
                                                                    const liveKey = `${group.matchKey}__${b.telegram_id || "u"}`;
                                                                    const isOpen = !!expandedLiveUsers[liveKey];

                                                                    return (
                                                                        <li key={`${b.telegram_id || "u"}_${idx}`}>
                                                                            <span
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => toggleLiveUserExpansion(group.matchKey, b.telegram_id)}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                                        e.preventDefault();
                                                                                        toggleLiveUserExpansion(group.matchKey, b.telegram_id);
                                                                                    }
                                                                                }}
                                                                                style={{cursor: "pointer"}}
                                                                            >
                                                                                <strong>{fmtUser(b)}</strong>
                                                                                {b.generated_time ? ` · ${formatKyivTime(b.generated_time)}` : ""}
                                                                            </span>

                                                                            {isOpen && (
                                                                                <div style={{marginTop: 6}}>
                                                                                    {hasContent(f.top3) ? (
                                                                                        <div>
                                                                                            <strong
                                                                                                style={{color: 'red'}}>Ставка:</strong> {renderMaybeList(f.top3)}
                                                                                        </div>
                                                                                    ) : (
                                                                                        <em>—</em>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </li>
                                                                    );
                                                                })}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        <div className={styles.betActions}>
                                            <button
                                                className={styles.deleteButton}
                                                onClick={() => handleDeleteBet(group.matchName, group.dateKey)}
                                            >
                                                Видалити
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <p>Ставок поки немає</p>
                        )}


                        {(groupedMatches.length > pageSize || betsHasMore) && (
                            <div style={{textAlign: "center", marginTop: 12}}>
                                <button
                                    type="button"
                                    className={styles.beautifulButton}
                                    onClick={() => {
                                        if (groupedMatches.length > pageSize) {
                                            setPageSize(ps => ps + 50);
                                        } else {
                                            loadAdminBetsPage();
                                        }
                                    }}
                                    disabled={betsLoading}
                                >
                                    {betsLoading
                                        ? "Завантажую…"
                                        : groupedMatches.length > pageSize
                                            ? "Показати ще 50"
                                            : "Підвантажити ще ставки"}
                                </button>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeTab === "stats" && (
                <>
                    <h2 className={styles.matchTitle}>Статистика</h2>
                    <div className={styles.animatedGradient}></div>
                    <p style={{opacity: 0.85, marginTop: 8}}>
                        <em>Залученість = (унікальні люди зі ставкою цього дня / всі користувачі з
                            доступом) × 100.</em>
                    </p>

                    {dailyStats.length === 0 ? (
                        <p>Немає даних</p>
                    ) : (
                        <div className={styles.buttonGroup}>
                            {dailyStats.map((r) => (
                                <div key={r.dateKey} className={styles.betBlock}>
                                    <div className={styles.betTitle}>
                                        <strong>{formatUADate(r.dateKey)}</strong>
                                        <span className={styles.byUser}>
                                            · матчів: {r.matches} · унікальних ставок: {r.uniqueBets} · людей: {r.engagedUsers}
                                        </span>
                                    </div>

                                    <div className={styles.betInfo}>
                                        <p>
                                            <strong>Залученість:</strong> {r.engagedUsers} / {r.totalEligibleUsers} ({r.efficiency}%)
                                        </p>

                                        <div
                                            style={{
                                                height: 10,
                                                borderRadius: 8,
                                                background: "rgba(255,255,255,0.15)",
                                                overflow: "hidden",
                                                marginTop: 6,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    height: "100%",
                                                    width: `${Math.max(0, Math.min(100, r.efficiency))}%`,
                                                    background: "rgba(255,255,255,0.55)",
                                                }}
                                            />
                                        </div>


                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </>
            )}

            {activeTab === "broadcast" && (
                <>
                    <h2 className={styles.matchTitle}>Розсилка</h2>
                    <div className={styles.animatedGradient}></div>

                    <div className={styles.betBlock}>
                        <div className={styles.betInfo}>
                            <p style={{marginTop: 0}}>
                                <strong>Кому надсилати</strong>
                            </p>

                            <div style={{display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center"}}>
                                <label style={{display: "flex", gap: 6, alignItems: "center"}}>
                                    <input
                                        type="radio"
                                        name="broadcastTarget"
                                        value="all"
                                        checked={broadcastTarget === "all"}
                                        onChange={() => setBroadcastTarget("all")}
                                    />
                                    Всім
                                </label>

                                <label style={{display: "flex", gap: 6, alignItems: "center"}}>
                                    <input
                                        type="radio"
                                        name="broadcastTarget"
                                        value="access"
                                        checked={broadcastTarget === "access"}
                                        onChange={() => setBroadcastTarget("access")}
                                    />
                                    Тільки з доступом
                                </label>

                                <label style={{display: "flex", gap: 6, alignItems: "center"}}>
                                    <input
                                        type="radio"
                                        name="broadcastTarget"
                                        value="no_access"
                                        checked={broadcastTarget === "no_access"}
                                        onChange={() => setBroadcastTarget("no_access")}
                                    />
                                    Всім без доступу
                                </label>

                                <label style={{display: "flex", gap: 6, alignItems: "center"}}>
                                    <input
                                        type="radio"
                                        name="broadcastTarget"
                                        value="user"
                                        checked={broadcastTarget === "user"}
                                        onChange={() => setBroadcastTarget("user")}
                                    />
                                    Певному юзеру
                                </label>
                            </div>

                            {broadcastTarget === "user" && (
                                <div style={{marginTop: 10}}>
                                    <select
                                        value={broadcastUserId}
                                        onChange={(e) => setBroadcastUserId(e.target.value)}
                                        style={{width: "100%", padding: "10px", borderRadius: 8, color: "black"}}
                                    >
                                        <option value="">— Обери користувача —</option>
                                        {(users || []).map((u) => (
                                            <option key={u.telegram_id} value={u.telegram_id}>
                                                {fmtUserLabel(u)}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            <div style={{marginTop: 14}}>
                                <p><strong>Повідомлення</strong></p>
                                <textarea
                                    value={broadcastText}
                                    onChange={(e) => setBroadcastText(e.target.value)}
                                    placeholder="Введіть текст повідомлення…"
                                    style={{
                                        width: "100%",
                                        minHeight: 120,
                                        padding: "10px",
                                        borderRadius: 8,
                                        resize: "vertical",
                                        color: "black"
                                    }}
                                />
                            </div>

                            <div style={{marginTop: 14}}>
                                <p><strong>Фото (необов’язково)</strong></p>
                                <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={(e) => setBroadcastPhotos(Array.from(e.target.files || []))}
                                />
                                {broadcastPhotos.length > 0 && (
                                    <div style={{marginTop: 6, opacity: 0.85}}>
                                        Обрано: <strong>{broadcastPhotos.length}</strong>
                                        {broadcastPhotos.length === 1 ? " фото" : " фото"}
                                        <div style={{marginTop: 6}}>
                                            {broadcastPhotos.map((file, idx) => (
                                                <div key={`${file.name}_${idx}`}>{file.name}</div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div style={{
                                marginTop: 16,
                                display: "flex",
                                gap: 10,
                                alignItems: "center",
                                flexWrap: "wrap"
                            }}>
                                <button
                                    type="button"
                                    className={styles.beautifulButton}
                                    onClick={handleSendBroadcast}
                                    disabled={broadcastSending}
                                >
                                    {broadcastSending ? "Надіслати…" : "Надіслати"}
                                </button>

                                <button
                                    type="button"
                                    className={styles.beautifulButton}
                                    onClick={() => {
                                        setBroadcastText("");
                                        setBroadcastPhotos([]);
                                        setBroadcastStatus("");
                                    }}
                                    disabled={broadcastSending}
                                >
                                    Очистити
                                </button>

                                {broadcastStatus && <span style={{opacity: 0.9}}>{broadcastStatus}</span>}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeTab === "bonuses" && (
                <>
                    <h2 className={styles.matchTitle}>Бонуси</h2>
                    <div className={styles.animatedGradient}></div>

                    <div className={styles.betBlock}>
                        <div className={styles.betInfo}>
                            <p style={{marginTop: 0}}>
                                <strong>Реферальні заявки</strong>
                            </p>
                            <p style={{opacity: 0.85}}>
                                Підтверджуй тільки якщо людина реально зареєструвалась по твоїй рефці і зробила деп.
                            </p>
                            <button
                                className={styles.beautifulButton}
                                type="button"
                                onClick={fetchBonuses}
                                disabled={bonusLoading}
                            >
                                {bonusLoading ? "Оновлюю…" : "Оновити"}
                            </button>
                            {bonusStatus && <span style={{marginLeft: 10, opacity: 0.9}}>{bonusStatus}</span>}
                        </div>
                    </div>

                    <div className={styles.buttonGroup}>
                        {referralRequests.length ? referralRequests.map((req) => {
                            const invitedName = req.invited_username
                                ? `@${req.invited_username}`
                                : `${req.invited_first_name || ""} ${req.invited_last_name || ""}`.trim() || `id:${req.invited_telegram_id}`;
                            const referrerName = req.referrer_username
                                ? `@${req.referrer_username}`
                                : `${req.referrer_first_name || ""} ${req.referrer_last_name || ""}`.trim() || `id:${req.referrer_telegram_id}`;
                            return (
                                <div key={req.id} className={styles.betBlock}>
                                    <div className={styles.betTitle}>
                                        <strong>{invitedName}</strong>
                                        <span className={styles.byUser}> · запросив {referrerName}</span>
                                    </div>
                                    <div className={styles.betInfo}>
                                        <p><strong>Новий юзер:</strong> {req.invited_telegram_id}</p>
                                        <p><strong>Друг:</strong> {req.referrer_telegram_id}</p>
                                        <p><strong>Нагорода:</strong> {req.reward_points} балів</p>
                                        <p><strong>Створено:</strong> {formatKyivTime(req.created_at)}</p>
                                        <div style={{display: "flex", gap: 10, flexWrap: "wrap", marginTop: 10}}>
                                            <button
                                                type="button"
                                                className={styles.beautifulButton}
                                                onClick={() => processReferral(req.id, "approved", req.reward_points)}
                                            >
                                                Підтвердити деп
                                            </button>
                                            <button
                                                type="button"
                                                className={styles.deleteButton}
                                                onClick={() => processReferral(req.id, "rejected", req.reward_points)}
                                            >
                                                Відхилити
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        }) : (
                            <p>Pending реферальних заявок немає</p>
                        )}
                    </div>

                    <h2 className={styles.matchTitle}>Покупки магазину</h2>
                    <div className={styles.animatedGradient}></div>
                    <div className={styles.buttonGroup}>
                        {shopPurchases.length ? shopPurchases.map((purchase) => {
                            const buyer = purchase.username
                                ? `@${purchase.username}`
                                : `${purchase.first_name || ""} ${purchase.last_name || ""}`.trim() || `id:${purchase.telegram_id}`;
                            const title = purchase.meta?.title || purchase.item_key;
                            return (
                                <div key={purchase.id} className={styles.betBlock}>
                                    <div className={styles.betTitle}>
                                        <strong>{title}</strong>
                                        <span className={styles.byUser}> · {buyer}</span>
                                    </div>
                                    <div className={styles.betInfo}>
                                        <p><strong>ID юзера:</strong> {purchase.telegram_id}</p>
                                        <p><strong>Списано:</strong> {purchase.points_spent} балів</p>
                                        <p><strong>Статус:</strong> {purchase.status}</p>
                                        <p><strong>Створено:</strong> {formatKyivTime(purchase.created_at)}</p>
                                        <div style={{display: "flex", gap: 10, flexWrap: "wrap", marginTop: 10}}>
                                            <button
                                                type="button"
                                                className={styles.beautifulButton}
                                                onClick={() => processShopPurchase(purchase.id, "completed")}
                                            >
                                                Виконано
                                            </button>
                                            <button
                                                type="button"
                                                className={styles.deleteButton}
                                                onClick={() => processShopPurchase(purchase.id, "canceled")}
                                            >
                                                Скасувати
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        }) : (
                            <p>Pending покупок немає</p>
                        )}
                    </div>
                </>
            )}

            {activeTab === "affiliate" && (
                <>
                    <h2 className={styles.matchTitle}>ID доступу</h2>
                    <div className={styles.animatedGradient}></div>

                    <section className={styles.affiliatePanel}>
                        <div className={styles.affiliateHero}>
                            <div>
                                <span className={styles.affiliateEyebrow}>Access ID</span>
                                <h3>Прив'язка юзера до зовнішнього ID</h3>
                                <p>
                                    Стару партнерку й API-синхронізацію прибрано. Тепер юзер вводить свій ID як код доступу,
                                    а після ручного підтвердження цей ID прив'язується до Telegram-акаунта.
                                </p>
                            </div>
                            <div className={styles.affiliateHeroMeta}>
                                <span>З доступом: <strong>{users.filter((u) => u.has_access).length}</strong></span>
                                <span>З ID: <strong>{users.filter((u) => u.external_id).length}</strong></span>
                                <span>Без ID: <strong>{users.filter((u) => !u.external_id).length}</strong></span>
                                <button type="button" className={styles.miniDangerButton} onClick={clearAllExternalIdLinks}>
                                    Очистити ID
                                </button>
                            </div>
                        </div>

                        <div className={styles.affiliateCard}>
                            <div className={styles.affiliateCardHeader}>
                                <div>
                                    <strong>Пошук</strong>
                                    <span>Можна шукати по Telegram ID, @ніку або зовнішньому ID.</span>
                                </div>
                            </div>
                            <div className={styles.affiliateSearchRow}>
                                <input
                                    className={styles.affiliateInput}
                                    value={affiliateQuery}
                                    onChange={(e) => setAffiliateQuery(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") fetchAffiliateProfile();
                                    }}
                                    placeholder="TG ID, @нік або зовнішній ID"
                                />
                                <button type="button" className={styles.beautifulButton} onClick={() => fetchAffiliateProfile()} disabled={affiliateLoading}>
                                    {affiliateLoading ? "Шукаю…" : "Показати"}
                                </button>
                            </div>
                        </div>

                        <div className={styles.affiliateCard}>
                            <div className={styles.affiliateCardHeader}>
                                <div>
                                    <strong>Ручна прив'язка</strong>
                                    <span>Якщо треба виправити або додати ID вручну, обери TG юзера і впиши його зовнішній ID.</span>
                                </div>
                            </div>
                            <div className={styles.affiliateFormGrid}>
                                <input
                                    className={styles.affiliateInput}
                                    type="text"
                                    inputMode="text"
                                    autoComplete="off"
                                    list="affiliate-users-list"
                                    value={affiliateLinkTelegramId}
                                    onChange={(e) => setAffiliateLinkTelegramId(e.target.value)}
                                    placeholder="Telegram ID або @нік"
                                />
                                <input
                                    className={styles.affiliateInput}
                                    value={affiliateLinkCid}
                                    onChange={(e) => setAffiliateLinkCid(e.target.value.trim())}
                                    placeholder="Зовнішній ID"
                                />
                                <input
                                    className={styles.affiliateInput}
                                    value={affiliateLinkNote}
                                    onChange={(e) => setAffiliateLinkNote(e.target.value)}
                                    placeholder="Нотатка"
                                />
                            </div>
                            <datalist id="affiliate-users-list">
                                {(users || []).flatMap((u) => {
                                    const options = [
                                        <option key={`aff-user-id-${u.telegram_id}`} value={u.telegram_id}>
                                            {fmtUserLabel(u)}
                                        </option>
                                    ];
                                    if (u.username) {
                                        options.push(
                                            <option key={`aff-user-username-${u.telegram_id}`} value={`@${u.username}`}>
                                                {fmtUserLabel(u)}
                                            </option>
                                        );
                                    }
                                    return options;
                                })}
                            </datalist>
                            <div className={styles.affiliateActions}>
                                <button type="button" className={styles.beautifulButton} onClick={linkAffiliateUser} disabled={affiliateLoading}>
                                    Зберегти зв'язку
                                </button>
                            </div>
                            {affiliateStatus && <p className={styles.affiliateStatus}>{affiliateStatus}</p>}
                        </div>

                        {affiliateProfile?.user && (
                            <div className={styles.affiliateProfileGrid}>
                                <div className={styles.affiliateCard}>
                                    <div className={styles.affiliateProfileHead}>
                                        <div>
                                            <span className={styles.affiliateEyebrow}>Профіль</span>
                                            <h3>{affiliateUserTitle(affiliateProfile.user)}</h3>
                                            <p>TG ID: <strong>{affiliateProfile.user.telegram_id}</strong></p>
                                        </div>
                                        {affiliateProfile.user && (
                                            <a className={styles.affiliateTelegramLink} href={affiliateProfileUrl(affiliateProfile.user)} target="_blank" rel="noreferrer">
                                                Telegram
                                            </a>
                                        )}
                                    </div>
                                    <div className={styles.affiliateMiniStats}>
                                        <span>ID <strong>{affiliateProfile.link?.external_id || "не прив'язаний"}</strong></span>
                                        <span>Доступ <strong>{affiliateProfile.user.has_access ? "є" : "немає"}</strong></span>
                                        <span>Ставок <strong>{affiliateProfile.user.total_bets || 0}</strong></span>
                                        <span>Роль <strong>{affiliateProfile.user.role || "user"}</strong></span>
                                    </div>
                                    <p className={styles.affiliateMuted}>
                                        Вперше в боті: {formatKyivTime(affiliateProfile.user.created_at) || "немає даних"} ·
                                        Перший доступ: {formatKyivTime(affiliateProfile.user.first_access_at) || "ще не було"} ·
                                        Останній вхід: {formatKyivTime(affiliateProfile.user.last_login) || "немає даних"}
                                    </p>
                                </div>
                            </div>
                        )}
                        {affiliateProfile && !affiliateProfile.user && (
                            <div className={styles.affiliateCard}>
                                <p className={styles.affiliateMuted}>Нічого не знайдено. Перевір TG ID, @нік або зовнішній ID.</p>
                            </div>
                        )}
                    </section>
                </>
            )}

            {activeTab === "settings" && (
                <>
                    <h2 className={styles.matchTitle}>Налаштування</h2>
                    <div className={styles.animatedGradient}></div>

                    <div className={styles.settingsPanel}>
                        <div className={styles.settingsHeader}>
                            <div>
                                <h3>Канальні пости і автодії</h3>
                                <p>Ці налаштування читає backend і worker з <code>users.db</code>.</p>
                            </div>
                            <button
                                type="button"
                                className={styles.beautifulButton}
                                onClick={fetchAdminSettings}
                                disabled={settingsLoading || settingsSaving}
                            >
                                {settingsLoading ? "Оновлюю…" : "Оновити"}
                            </button>
                        </div>

                        <div className={styles.settingsGrid}>
	                            <label className={styles.settingsField}>
	                                <span>ID адміна для щоденних чернеток</span>
	                                <input
	                                    value={adminSettings.admin_review_id || ""}
	                                    onChange={(e) => updateSettingField("admin_review_id", e.target.value)}
	                                    placeholder="1078623102"
	                                />
	                                <small>Сюди приходитимуть щоденні чернетки постів. Заявки на доступ тепер зберігаються у вкладці «Заявки» без повідомлень у чат.</small>
	                            </label>

                            <label className={styles.settingsField}>
                                <span>ID чату для публікації</span>
                                <input
                                    value={adminSettings.daily_publication_chat_id || adminSettings.daily_channel_id || ""}
                                    onChange={(e) => updateSettingField("daily_publication_chat_id", e.target.value)}
                                    placeholder="-100... chat_id"
                                />
                                <small>Ставка дня і підсумок можуть одночасно виходити в чат і канал.</small>
                            </label>

                            <label className={styles.settingsField}>
                                <span>ID каналу для публікації</span>
                                <input
                                    value={adminSettings.daily_publication_channel_id || adminSettings.daily_channel_id || ""}
                                    onChange={(e) => updateSettingField("daily_publication_channel_id", e.target.value)}
                                    placeholder="-100... channel_id"
                                />
                            </label>

                            <label className={styles.settingsField}>
                                <span>ID теми в чаті, якщо чат з топіками</span>
                                <input
                                    value={adminSettings.daily_publication_thread_id || ""}
                                    onChange={(e) => updateSettingField("daily_publication_thread_id", e.target.value)}
                                    placeholder="Пусто, якщо постити без теми"
                                />
                            </label>

                            <label className={styles.settingsField}>
                                <span>Посилання на бота для кнопки “Інші ставки”</span>
                                <input
                                    value={adminSettings.bot_public_url || ""}
                                    onChange={(e) => updateSettingField("bot_public_url", e.target.value)}
                                    placeholder="https://t.me/..."
                                />
                            </label>

                            <label className={styles.settingsField}>
                                <span>ID каналу Сім’я Грача для перевірки доступу</span>
                                <input
                                    value={adminSettings.grach_family_channel_id || ""}
                                    onChange={(e) => updateSettingField("grach_family_channel_id", e.target.value)}
                                    placeholder="-100..."
                                />
                            </label>

                            <label className={styles.settingsField}>
                                <span>Час чернеток ставки дня</span>
                                <input
                                    type="time"
                                    value={adminSettings.daily_channel_post_time || "10:00"}
                                    onChange={(e) => updateSettingField("daily_channel_post_time", e.target.value)}
                                />
                            </label>

                            <label className={styles.settingsField}>
                                <span>Час адмін-звіту по ставках</span>
                                <input
                                    type="time"
                                    value={adminSettings.daily_admin_report_time || "02:30"}
                                    onChange={(e) => updateSettingField("daily_admin_report_time", e.target.value)}
                                />
                            </label>

                            <label className={styles.settingsField}>
                                <span>Затримка підсумкового поста після фіналу</span>
                                <input
                                    type="number"
                                    min="0"
                                    max="1440"
                                    step="5"
                                    value={adminSettings.daily_result_delay_minutes ?? 15}
                                    onChange={(e) => updateSettingField("daily_result_delay_minutes", Number(e.target.value || 0))}
                                />
                                <small>У хвилинах. Перевірка завершених матчів відбувається кожні 5 хвилин.</small>
                            </label>

                            <label className={styles.settingsField}>
                                <span>Якість AI-фото</span>
                                <select
                                    value={adminSettings.daily_post_image_quality || "low"}
                                    onChange={(e) => updateSettingField("daily_post_image_quality", e.target.value)}
                                >
                                    <option value="low">Low — найдешевше</option>
                                    <option value="medium">Medium — баланс</option>
                                    <option value="high">High — максимум</option>
                                    <option value="auto">Auto</option>
                                </select>
                                <small>Фото генерується один раз і повторно використовується для підсумку.</small>
                            </label>

                            <label className={`${styles.settingsField} ${styles.settingsTemplateField}`}>
                                <span>Шаблон поста «Ставка дня»</span>
                                <textarea
                                    rows="14"
                                    value={adminSettings.daily_regular_post_template || ""}
                                    onChange={(e) => updateSettingField("daily_regular_post_template", e.target.value)}
                                    placeholder="Завантажується стандартний шаблон…"
                                />
                                <small>Можна міняти порядок блоків, текст, емодзі та HTML-теги &lt;b&gt;, &lt;i&gt;, &lt;blockquote&gt;. Текст у кутових дужках пояснює моделі, що саме вставити.</small>
                                <button
                                    type="button"
                                    className={styles.templateResetButton}
                                    onClick={() => updateSettingField("daily_regular_post_template", DEFAULT_REGULAR_POST_TEMPLATE)}
                                >
                                    Повернути стандартний шаблон
                                </button>
                            </label>

                            <label className={`${styles.settingsField} ${styles.settingsTemplateField}`}>
                                <span>Шаблон підсумку «Ставки дня»</span>
                                <textarea
                                    rows="12"
                                    value={adminSettings.daily_result_post_template || ""}
                                    onChange={(e) => updateSettingField("daily_result_post_template", e.target.value)}
                                    placeholder="Завантажується стандартний шаблон…"
                                />
                                <small>Після фіналу бот перевіряє ставку, додає рахунок і пише аргументи лише за фактичними даними матчу.</small>
                                <button
                                    type="button"
                                    className={styles.templateResetButton}
                                    onClick={() => updateSettingField("daily_result_post_template", DEFAULT_RESULT_POST_TEMPLATE)}
                                >
                                    Повернути стандартний шаблон
                                </button>
                            </label>
                        </div>

                        <div className={styles.settingsToggleList}>
                            {[
                                ["daily_channel_posts_enabled", "Автоматично надсилати щоденні чернетки"],
                                ["daily_channel_regular_enabled", "Чернетка звичайної ставки дня"],
                                ["daily_channel_risk_enabled", "Чернетка Ризику дня"],
                                ["daily_publish_to_chat_enabled", "Публікувати погоджені пости в чат"],
                                ["daily_publish_to_channel_enabled", "Публікувати погоджені пости в канал"],
                                ["daily_post_images_enabled", "Генерувати AI-фото для постів"],
                                ["daily_post_require_approval", "Погоджувати Ставку дня перед публікацією"],
                                ["daily_result_posts_enabled", "Створювати підсумок після завершення матчу"],
                                ["daily_result_require_approval", "Погоджувати підсумок перед публікацією"],
                                ["daily_admin_report_enabled", "Щоденний адмін-звіт по ставках"],
                                ["scheduled_broadcasts_enabled", "Заплановані розсилки користувачам"],
                                ["daily_matches_refresh_enabled", "Щоденне оновлення матчів на наступні дні"],
                                ["app_locked", "Закрити вхід у WebApp для користувачів"],
                            ].map(([key, label]) => (
                                <label key={key} className={styles.settingsToggleRow}>
                                    <span>{label}</span>
                                    <input
                                        type="checkbox"
                                        checked={!!adminSettings[key]}
                                        onChange={(e) => updateSettingField(key, e.target.checked)}
                                    />
                                </label>
                            ))}
                        </div>

                        <div className={styles.settingsActions}>
                            <button
                                type="button"
                                className={styles.beautifulButton}
                                onClick={saveAdminSettings}
                                disabled={settingsSaving}
                            >
                                {settingsSaving ? "Зберігаю…" : "Зберегти налаштування"}
                            </button>
                            {settingsStatus && <span>{settingsStatus}</span>}
                        </div>
                    </div>
                </>
            )}

            {activeTab === "schedule" && (
                <>
                    <h2 className={styles.matchTitle}>Заплановані повідомлення</h2>
                    <div className={styles.animatedGradient}></div>

                    <div className={styles.betBlock}>
                        <div className={styles.betInfo}>
                            <p style={{marginTop: 0}}>
                                <strong>Шаблон підтримує змінні:</strong>{" "}
                                <code>{"{{matches_today}}"}</code>, <code>{"{{weekday_today}}"}</code>,{" "}
                                <code>{"{{date_today}}"}</code>, <code>{"{{first_name}}"}</code>,{" "}
                                <code>{"{{username}}"}</code>, <code>{"{{no_bet_text}}"}</code>
                            </p>

                            <div style={{display: "flex", gap: 10, flexWrap: "wrap"}}>
                                <input
                                    value={schedTitle}
                                    onChange={(e) => setSchedTitle(e.target.value)}
                                    placeholder="Назва (необов'язково)"
                                    style={{flex: 1, minWidth: 200, padding: 10, borderRadius: 8, color: "black"}}
                                />

                                <select
                                    value={schedTarget}
                                    onChange={(e) => setSchedTarget(e.target.value)}
                                    style={{padding: 10, borderRadius: 8, color: "black"}}
                                >
                                    <option value="access">Тільки з доступом</option>
                                    <option value="all">Всім</option>
                                </select>

                                <input
                                    type="time"
                                    value={schedTime}
                                    onChange={(e) => setSchedTime(e.target.value)}
                                    style={{padding: 10, borderRadius: 8, color: "black"}}
                                />

                                <input
                                    value={schedMinMatches}
                                    onChange={(e) => setSchedMinMatches(e.target.value.replace(/[^\d]/g, ""))}
                                    placeholder="min матчів"
                                    style={{width: 120, padding: 10, borderRadius: 8, color: "black"}}
                                />

                                <label style={{display: "flex", alignItems: "center", gap: 6}}>
                                    <input
                                        type="checkbox"
                                        checked={schedEnabled}
                                        onChange={(e) => setSchedEnabled(e.target.checked)}
                                    />
                                    Увімкнено
                                </label>
                            </div>

                            <div style={{marginTop: 10}}>
                                {schedPreviewOpen && (
                                    <div
                                        onClick={closeSchedulePhotoPreview}
                                        style={{
                                            position: "fixed",
                                            inset: 0,
                                            background: "rgba(0,0,0,0.6)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            zIndex: 9999,
                                            padding: 16,
                                        }}
                                    >
                                        <div
                                            onClick={(e) => e.stopPropagation()}
                                            style={{
                                                maxWidth: "min(920px, 96vw)",
                                                maxHeight: "92vh",
                                                width: "100%",
                                                background: "rgba(0,0,0,0.85)",
                                                borderRadius: 12,
                                                overflow: "hidden",
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: 12
                                            }}>
                                                <div style={{
                                                    color: "white",
                                                    fontWeight: 700,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }}>
                                                    {schedPreviewTitle}
                                                </div>
                                                <button className={styles.beautifulButton} type="button"
                                                        onClick={closeSchedulePhotoPreview}>
                                                    Закрити
                                                </button>
                                            </div>

                                            <div style={{
                                                padding: 12,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                                {schedPreviewUrl ? (
                                                    <img
                                                        src={schedPreviewUrl}
                                                        alt="schedule preview"
                                                        style={{
                                                            maxWidth: "100%",
                                                            maxHeight: "78vh",
                                                            objectFit: "contain",
                                                            borderRadius: 10,
                                                        }}
                                                    />
                                                ) : (
                                                    <div style={{color: "white"}}>Завантаження…</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <textarea
                                    value={schedTemplate}
                                    onChange={(e) => setSchedTemplate(e.target.value)}
                                    style={{
                                        width: "100%",
                                        minHeight: 140,
                                        padding: 10,
                                        borderRadius: 8,
                                        resize: "vertical",
                                        color: "black",
                                    }}
                                />
                            </div>

                            <div style={{marginTop: 10}}>
                                <p><strong>Фото (необовʼязково)</strong></p>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setSchedPhoto(e.target.files?.[0] || null)}
                                />
                                {schedPhoto && (
                                    <div style={{marginTop: 6, opacity: 0.85}}>
                                        Обрано: <strong>{schedPhoto.name}</strong>
                                    </div>
                                )}
                            </div>

                            <div style={{
                                marginTop: 12,
                                display: "flex",
                                gap: 10,
                                flexWrap: "wrap",
                                alignItems: "center"
                            }}>
                                <button className={styles.beautifulButton} type="button" onClick={saveSchedule}>
                                    {schedEditId ? "Оновити" : "Створити"}
                                </button>

                                <button className={styles.beautifulButton} type="button" onClick={resetScheduleForm}>
                                    Очистити форму
                                </button>

                                <button className={styles.beautifulButton} type="button" onClick={fetchSchedules}
                                        disabled={schedLoading}>
                                    {schedLoading ? "Оновлюю…" : "Оновити список"}
                                </button>

                                {schedStatus && <span style={{opacity: 0.9}}>{schedStatus}</span>}
                            </div>
                        </div>
                    </div>

                    <div className={styles.buttonGroup} style={{marginTop: 12}}>
                        {schedules.length === 0 ? (
                            <p>Немає запланованих повідомлень</p>
                        ) : (
                            schedules.map((s) => (
                                <div
                                    key={s.id}
                                    className={styles.betBlock}
                                    style={{maxWidth: "100%", overflow: "hidden"}}
                                >
                                    <div className={styles.betTitle}>
                                        <strong>{s.title || `#${s.id}`}</strong>
                                        <span className={styles.byUser}>
· {s.enabled ? "увімкнено" : "вимкнено"} · {s.target} · {s.send_time}
                                            {s.has_photo ? ` · 📷 ${s.photo_name || "photo"}` : ""}
                                            {s.min_matches != null ? ` · min матчів: ${s.min_matches}` : ""}
                                            {s.last_sent_date ? ` · останнє: ${formatUADate(s.last_sent_date)}` : ""}
              </span>
                                    </div>

                                    <div className={styles.betInfo}>
                                        <pre
                                            className={styles.preJSON}
                                            style={{
                                                whiteSpace: "pre-wrap",      // wrap long lines
                                                wordBreak: "break-word",     // break very long words
                                                overflowX: "auto",           // scroll inside if needed
                                                maxWidth: "100%",            // never exceed container
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            {s.text_template}
                                        </pre>

                                        <div style={{display: "flex", gap: 10, marginTop: 8, flexWrap: "wrap"}}>
                                            <button className={styles.beautifulButton} type="button"
                                                    onClick={() => startEditSchedule(s)}>
                                                Редагувати
                                            </button>
                                            <button className={styles.deleteButton} type="button"
                                                    onClick={() => deleteSchedule(s.id)}>
                                                Видалити
                                            </button>
                                            {s.has_photo && (
                                                <button
                                                    className={styles.beautifulButton}
                                                    type="button"
                                                    onClick={() => openSchedulePhotoPreview(s)}
                                                >
                                                    Переглянути фото
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default AdminPage;
